import styled from 'styled-components'

export const Main = styled.main`
	grid-area: main;
	display: grid;
	width: 100%;
	padding: 0 12px 12px;
	max-width: 1200px;
	margin: 0 auto;
	grid-template-columns: 1fr 384px;
	gap: 24px;
	position: relative;

	@media only screen and (max-width: 999px) {
		grid-template-columns: 1fr;
	}
`
